export default __webpack_public_path__ + "static/media/household-2.c8f1992e.jpg";